module.exports = __webpack_public_path__ + "static/media/diamond--big.a52085a2.png";